import { useContext } from "react";
import { LanguageContext } from "../../LanguageProvider";
import { useNavigate } from "react-router";

export const PresentationContainer = () => {
  const navigate = useNavigate();

  const navigateToContactPage = () => {
    navigate("/contact");
  };

  const { polish } = useContext(LanguageContext);

  return (
    <div className="bg-silver h-[30rem] p-2 lg:p-10 flex justify-around">
      {!polish && (
        <div className="my-description ml-4 h-full lg:w-3/6 flex flex-col justify-center">
          <h1 className="sm:text-3xl 2xl:text-5xl text-white mb-2">
            I'm Beata Gonera.
          </h1>
          <h1 className="sm:text-3xl 2xl:text-5xl text-white mb-8 2xl:text-right">
            <span className="text-yellow-orange">Fullstack </span>Developer
          </h1>
          <div className="w-4/5">
            <p className="text-md text-white leading-6 mb-8">
              Currently developing Next.js applications with Wordpress as
              headless CMS.
            </p>
          </div>
          <button
            className="bg-yellow-orange h-9 w-28 rounded-sm text-sm hover:bg-white"
            onClick={navigateToContactPage}
          >
            Contact me
          </button>
        </div>
      )}

      {polish && (
        <div className="my-description ml-4 h-full lg:w-3/6 flex flex-col justify-center">
          <h1 className="sm:text-3xl 2xl:text-5xl text-white mb-2">
            Beata Gonera
          </h1>
          <h1 className="sm:text-3xl 2xl:text-5xl text-white mb-8 2xl:text-right">
            <span className="text-yellow-orange">Fullstack </span>Developer
          </h1>
          <div className="w-4/5">
            <p className="text-md text-white leading-6 mb-4">
              Obecnie tworzę aplikacje oparte na Next.js i headless Wordpress
              CMS dla Grupy Alesoft.
            </p>
          </div>
          <button
            className="bg-yellow-orange h-9 w-28 rounded-sm text-sm hover:bg-white"
            onClick={navigateToContactPage}
          >
            Kontakt
          </button>
        </div>
      )}

      <div
        className="photo hidden lg:block xl:w-[19rem] xl:h-[32rem] bg-cover mt-8"
        style={{ backgroundImage: "url(My-photo.webp)" }}
      ></div>
    </div>
  );
};
